module.exports = __webpack_public_path__ + "img/lit_weekly.80f64a36.png";